exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-chart .user-chart-header[data-v-2305c6a4]{margin-top:10px;margin-bottom:10px}.user-chart .test-type-description[data-v-2305c6a4]{position:relative;color:#a7b7c2;margin-top:5px;display:block}.user-chart li:hover .user-chart-header .test-type-name[data-v-2305c6a4]{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2305c6a4","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/dashboard/ChartList.vue
// module id = UUbi
// module chunks = 0 1